import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useAutoLogout(inactivityLimit = 60 * 60 * 1000) { 
  const navigate = useNavigate();
  const inactivityTimerRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      handleLogout();
      return;
    }

    const resetInactivityTimer = () => {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
      inactivityTimerRef.current = setTimeout(() => {
        handleLogout();
      }, inactivityLimit);
    };

    const activityEvents = ['mousemove', 'keydown', 'mousedown', 'scroll', 'touchstart'];

    activityEvents.forEach(event => {
      window.addEventListener(event, resetInactivityTimer);
    });

    resetInactivityTimer(); 

    const onStorageChange = (e) => {
      if (e.key === 'logoutSignal') {
        handleLogout(false);
      }
    };
    window.addEventListener('storage', onStorageChange);

    return () => {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
      activityEvents.forEach(event => {
        window.removeEventListener(event, resetInactivityTimer);
      });
      window.removeEventListener('storage', onStorageChange);
    };
  }, []);

  function handleLogout(setSignal = true) {
    localStorage.removeItem('token');
    if (setSignal) {
      localStorage.setItem('logoutSignal', Date.now());
    }
    navigate('/');
  }
}
